import apiClient from '../client';
import {
  DashboardReportResponse,
  PortfolioAnalysisResponse,
  LoanPerformanceReportResponse,
  CustomerStatementResponse,
  DailyCollectionsReportResponse,
  ReportExportRequest,
  ReportQueryParams,
  DailyCollectionsQueryParams,
  CustomerStatementQueryParams,
  LoanPortfolioQueryParams,
  LoanPortfolioResponse,
} from '../types/report.types';

/**
 * Reports API endpoints
 */
export const reportsApi = {
  /**
   * Get dashboard summary report
   * CACHED: 5 minute TTL
   */
  getDashboard: async (): Promise<DashboardReportResponse> => {
    const response = await apiClient.get<DashboardReportResponse>('/reports/dashboard');
    return response.data;
  },

  /**
   * Get portfolio analysis report
   * CACHED: 15 minute TTL
   */
  getPortfolioAnalysis: async (params: ReportQueryParams): Promise<PortfolioAnalysisResponse> => {
    const response = await apiClient.get<PortfolioAnalysisResponse>('/reports/portfolio', {
      params,
    });
    return response.data;
  },

  /**
   * Get loan performance report
   */
  getLoanPerformance: async (params: ReportQueryParams): Promise<LoanPerformanceReportResponse> => {
    const response = await apiClient.get<LoanPerformanceReportResponse>('/reports/loan-performance', {
      params,
    });
    return response.data;
  },

  /**
   * Get customer statement
   */
  getCustomerStatement: async (params: CustomerStatementQueryParams): Promise<CustomerStatementResponse> => {
    const response = await apiClient.get<CustomerStatementResponse>('/reports/customer-statement', {
      params,
    });
    return response.data;
  },

  /**
   * Get daily collections report
   */
  getDailyCollections: async (params: DailyCollectionsQueryParams): Promise<DailyCollectionsReportResponse> => {
    const response = await apiClient.get<DailyCollectionsReportResponse>('/reports/daily', {
      params,
    });
    return response.data;
  },

  /**
   * Export report in PDF, Excel, or CSV format
   */
  exportReport: async (data: ReportExportRequest): Promise<Blob> => {
    const response = await apiClient.post('/reports/export', data, {
      responseType: 'blob',
    });
    return response.data;
  },

  /**
   * Get loan portfolio report
   * Supports filtering by date range, status, product, and classification
   */
  getLoanPortfolio: async (params?: LoanPortfolioQueryParams): Promise<LoanPortfolioResponse> => {
    const response = await apiClient.get<LoanPortfolioResponse>('/reports/loan-portfolio', {
      params,
    });
    return response.data;
  },

  /**
   * Export loan portfolio report as Excel file
   */
  exportLoanPortfolio: async (params?: LoanPortfolioQueryParams): Promise<Blob> => {
    const response = await apiClient.get('/reports/loan-portfolio/export', {
      params,
      responseType: 'blob',
    });
    return response.data;
  },
};
